export default __webpack_public_path__ + "static/media/background.f19fdbe8.jpg";